import { BranchType } from "@/features/church/config/branches/types/branch.types"
import { getBranchDisplayLabel } from "@/shared/lib/branch/branch-display"

/**
 * User-facing label for the workspace system branch in permission scope pickers.
 * Avoid exposing internal enum names (e.g. "SYSTEM") in UI copy.
 */
export function permissionScopeLabelForBranchType(
  branchType: BranchType | string | undefined,
  branchName: string,
  t: (key: "parish" | "branch") => string
): string {
  return getBranchDisplayLabel({
    branchType,
    branchName,
    parishLabel: t("parish"),
    fallbackLabel: t("branch"),
  })
}
